// Announcement bar — handles the optional dismiss. The dismissal is remembered
// per-message (keyed off the message text) in localStorage, so changing the
// notice re-shows it to everyone. Progressive enhancement: with no JS the bar
// just stays visible (you only lose the dismiss button).

(function () {
  function init() {
    const el = document.querySelector('[data-announcement]');
    if (!el) return;

    const key = el.getAttribute('data-announcement-key');
    if (key) {
      try {
        if (localStorage.getItem('announcement:' + key) === '1') {
          el.remove();
          return;
        }
      } catch (e) {
        /* localStorage unavailable — just show the bar */
      }
    }

    const close = el.querySelector('[data-announcement-close]');
    if (close) {
      close.addEventListener('click', function () {
        if (key) {
          try {
            localStorage.setItem('announcement:' + key, '1');
          } catch (e) {
            /* ignore */
          }
        }
        el.remove();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
